import React, { useId } from "react";
import { AlertCircle } from "react-feather";
import { UncontrolledPopover, PopoverBody } from "reactstrap";

import * as S from "./styles";

export const InfoTooltip = ({ children, placement = "right" }) => {
  const targetId = `info-${useId().replace(/:/g, "")}`;

  return (
    <>
      <S.PopoverStyle />
      <S.Trigger type="button" id={targetId} aria-label="Mais informações">
        <AlertCircle size={16} />
      </S.Trigger>
      <UncontrolledPopover
        target={targetId}
        trigger="legacy"
        placement={placement}
        className="info-popover"
      >
        <PopoverBody className="info-popover-body">{children}</PopoverBody>
      </UncontrolledPopover>
    </>
  );
};
